import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Snackbar} from "@material-ui/core";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const style = (theme) => ({
    message: {
        display: 'flex',
        alignItems: 'center'
    },
    errorBar: {
        backgroundColor: theme.palette.error.dark
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1)
    }
});

class ErrorSnackbar extends Component {
    state = {
        open: true
    };

    handleClose = (e, reason) => {
        if (reason === 'clickaway') {
            // TODO - do we want this?
            return;
        }
        this.setState({open: false});
    };

    render() {
        const {classes, message} = this.props;
        const errorIconClasses = [classes.icon, classes.iconVariant].join(' ');
        return (
            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                open={this.state.open}
                onClose={(e, reason) => this.handleClose(e, reason)}
                aria-describedby="error-snackbar"
            >
                <SnackbarContent
                    className={classes.errorBar}
                    message={
                        <span id="error-snackbar" className={classes.message}>
                            <ErrorIcon className={errorIconClasses}/>
                            {message}
                        </span>
                    }
                    action={
                        <IconButton
                            href="#"
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={(e) => this.handleClose(e)}
                        >
                            <CloseIcon className={classes.icon} />
                        </IconButton>
                    }
                >

                </SnackbarContent>
            </Snackbar>
        );
    }
}


export default withStyles(style)(ErrorSnackbar);


